import { makeError } from "@shared/api/api";

export type ApiStatus = "S" | "F" | "W" | "E"; // S: 성공, F: 실패, W: 경고, E: 에러

export interface ApiErrorDetail {
  errorCode: string;
  errorTime: string; // "yyyy-MM-dd HH:mm:ss.SSS"
}

export interface ApiResponse<T = any> {
  status: ApiStatus;
  code: number;
  message: string;
  data: T | null;
  error?: ApiErrorDetail | null;
}

export class ApiError extends Error {
  status: ApiStatus;
  code: number;
  error?: ApiErrorDetail | null;

  constructor(status: ApiStatus, code: number, message: string, error?: ApiErrorDetail | null) {
    super(message);
    this.status = status;
    this.code = code;
    this.error = error;
  }

  static fromResponse(resp: ApiResponse<unknown>) {
    return new ApiError(resp.status, resp.code, resp.message, resp.error);
  }

  static badRequest(message: string, status: ApiStatus = 'F', error: ApiErrorDetail = makeError('BAD_REQUEST')) {
    return new ApiError(status, 400, message, error);
  }

  static serverError(message = "서버 오류가 발생하였습니다.", error: ApiErrorDetail = makeError('SERVER_ERROR')) {
    return new ApiError("E", 500, message, error);
  }



}